import {React, useEffect, useRef} from 'react';
import '../App.css';
import './faqs.css';
import Collapsible from "./Collapsible";
import { GiBirchTrees } from "react-icons/gi";
import Quest_video from '../images/SamsShort2.mp4';

const Faqs = () => {
        const stickyRef9 = useRef(null);
        const overlayRef9 = useRef(null);

        useEffect(() => {
            const handleScroll9 = () => {
             if (window.innerWidth <= 440) {
                    // If the viewport is 440px or less, do nothing
					overlayRef9.current.style.position = 'relative';
            		overlayRef9.current.style.top = '0';
                    return;
                  }
              const stickyRect9 = stickyRef9.current.getBoundingClientRect();
              const overlayRect9 = overlayRef9.current.getBoundingClientRect();
        
              if (stickyRect9.top <= 0 && stickyRect9.bottom > overlayRect9.height) {
                overlayRef9.current.style.position = 'fixed';
                overlayRef9.current.style.top = '0';
                /*overlayRef.current.style.width = `${stickyRef.current.offsetWidth}px`;*/
              } else if (stickyRect9.bottom <= overlayRect9.height) {
                overlayRef9.current.style.position = 'absolute';
                overlayRef9.current.style.top = `${stickyRect9.height - overlayRect9.height}px`;
              } else {
                overlayRef9.current.style.position = 'absolute';
                overlayRef9.current.style.top = '0';
              }
            };
        
            window.addEventListener('scroll', handleScroll9);
        
            return () => {
              window.removeEventListener('scroll', handleScroll9);
            };
          }, []);


    /*const collapsibleData = [
		{ title: "Can I Remove a Tree That's Too Close to My House?", content: "Yes, while a tree near your home can offer shade and beauty, it can also become a hazard over time. Falling leaves and debris may cause moisture damage, and overgrown branches can damage your siding or roof. Worse, an extensive root system could jeopardize your foundation. If the tree is becoming a problem, Sam's is a tree cutting service that can safely handle removal. Tree removal cost will vary depending on the size and location, and sometimes tree felling is needed. After removal, tree root removal can ensure that no regrowth threatens your home's foundation. Book an appointment today to get a free Tree removal estimate!" },
		{ title: "Do I Need a Permit to Remove a Tree?", content: "It depends. Many areas require a permit for tree removal, especially if the tree is large, located in a specific area, or considered a hazard. Factors like whether the tree is on public property, an invasive species, or near a street can also influence the need for a permit. An Arborist tree service like Sam's Tree Service, a licensed tree removal service in Sarasota and surrounding areas, can help assess whether you need a permit. As a certified arborist tree service and trusted tree specialist in the area, we'll guide you through the process and assist with any necessary applications." },
		{ title: "Do I need to be present while the tree work is being done?", content: "No, it's not necessary for you to be home as long as we have access to the property. Our team is fully equipped to handle the work independently, ensuring everything is done efficiently and safely." },
		{ title: "How much does tree trimming cost, and do you offer palm tree trimming services?", content: "The tree trimming cost depends on the size and type of the tree, as well as the complexity of the job. We offer specialized palm tree trimming services, ensuring your palms stay healthy and well-maintained. At Sam's Tree Service, we provide an affordable tree cutting service while delivering high-quality results. If you're looking for reliable tree trimmers in the Sarasota and Southwest Florida area , our experienced team is here to assist." },
	  ];*/

	  const collapsibleData = [
  {
    title: "Can I Remove a Tree That's Too Close to My House?",
    content: "Yes. Trees too close to your home can damage siding, roof, and even foundations over time. At Sam's Tree Service in Sarasota, our licensed arborists safely remove hazard trees of all sizes. Tree removal cost varies based on tree size and location. We also provide professional stump grinding and root removal to prevent regrowth. Contact us for a free tree removal estimate."
  },
  {
    title: "Do I Need a Permit to Remove a Tree?",
    content: "In many areas, you may need a permit for tree removal especially for large trees, heritage species, or public right-of-way removals. Sam's Tree Service can assess your situation, determine if a permit is required in Sarasota and surrounding areas, and assist with applications when needed."
  },
  {
    title: "Do I Need to Be Present While the Tree Work Is Being Done?",
    content: "No. You don't need to be onsite during tree removal or trimming as long as we have safe access to your property. Our team completes jobs efficiently using proper safety protocols."
  },
  {
    title: "How Much Does Tree Trimming Cost and Do You Offer Palm Tree Services?",
    content: "Tree trimming costs depend on tree size, species, and complexity of the job. We offer specialized palm tree trimming to keep palms healthy and properly shaped. Sam's Tree Service provides dependable, affordable tree trimming throughout Sarasota and Southwest Florida. Request a quote today."
  }
];


	  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": collapsibleData.map(item => ({
      "@type": "Question",
      "name": item.title,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": item.content
      }
    }))
  };

	return (
		<div id="modulefive9">
			{/* JSON-LD for Google */}
      		<script
        		type="application/ld+json"
        		dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      		/>
				<div   className="sticky-element-container9 ">
      				<div  ref={stickyRef9}className="background-div9">
        				<div ref={overlayRef9} className="overlay-container9">
          					<div id='about_overlayText9'>
							  	<div id='icon_five29'>
									<div id='five_text2_19'><h1> - - - - - -&nbsp;&nbsp;</h1></div>
									<div id='icon_five_icon29'><GiBirchTrees /></div>
									<div id='five_text2_29'><h1>&nbsp;&nbsp;- - - - - -</h1></div>
								</div>
            					<h1>Frequently Asked Questions</h1>
            					<p>Have questions about our services? Take a look at some frequently 
									asked questions below..</p>
          					</div>
							<div id='collapsible9'>
								<Collapsible collapsibleData={collapsibleData} />
							</div>
						</div>
						
          		 		<div id='video_faqsdiv9'>
							<div id='about_pic_div19'>	
								<video id='about_pic_div1_video9' autoPlay muted loop playsInline>
									<source src={Quest_video} type="video/mp4" />
										Your browser does not support the video tag.
								</video>
							</div>
							<div id='about_pic_div29'></div>
						</div>
      				</div>
				</div>
			</div>
	);
};

export default Faqs;